// import React, { useState, useEffect } from "react";
// import { Box, Typography } from "@mui/material";
// import EmployeeSelector from "../components/EmployeeSelector";
// import EmployeeTable from "../components/EmployeeTable";
// import PaginationControls from "../components/PaginationControls";
// import NotFoundEmployeesPopup from "../components/NotFoundEmployeesPopup";
// import EmployeeLookupDialog from "../components/EmployeeLookupDialog";
// import { useEmployeeHandlers } from "../hooks/useEmployeeHandlers";

// const IndividualEmployeesTable = ({ individuals, sendTableDataToParent, setError, examid, isEdit }) => {
//   const [searchTerm, setSearchTerm] = useState('');
//   const [page, setPage] = useState(1);
//   const [selectedEmployees, setSelectedEmployees] = useState([]);
//   const [notFoundEmployeeCodes, setNotFoundEmployeeCodes] = useState([]);
//   const [openNotFoundPopup, setOpenNotFoundPopup] = useState(false);
//   const [lookupOpen, setLookupOpen] = useState(false);
//   const rowsPerPage = 3;
//   const [employees, setEmployees] = useState([]);

//   const {
//     handleAddEmployees,
//     handleRemoveEmployee,
//     handleUploadExcel,
//     handleDownloadTemplate,
//     totalPages,
//     currentRows,
//     handlePageChange,
//     renderPageNumbers,
//     handleDeleteEmployee,
//     handleUndoEmployee
//   } = useEmployeeHandlers({
//     individuals,
//     sendTableDataToParent,
//     setError,
//     examid,
//     searchTerm,
//     page,
//     setPage,
//     selectedEmployees,
//     setSelectedEmployees,
//     notFoundEmployeeCodes,
//     setNotFoundEmployeeCodes,
//     openNotFoundPopup,
//     setOpenNotFoundPopup,
//     rowsPerPage
//   });

//   useEffect(() => {
//     setPage(1);
//   }, [searchTerm]);

//   return (
//     <Box className="individual-employees-section" sx={{ mb: 2 }}>
//       <Box sx={{
//         display: "flex",
//         flexDirection: { xs: "column", sm: "row" },
//         justifyContent: "space-between",
//         alignItems: { xs: "stretch", sm: "center" },
//         gap: 1.5,
//         mb: 1,
//         mt: 3
//       }}>
//         <Typography variant="h6">Individual Employees</Typography>
//       </Box>

//       {!isEdit && (
//         <EmployeeSelector
//           employees={employees}
//           selectedEmployees={selectedEmployees}   // Only for display count if needed
//           onOpenLookup={() => setLookupOpen(true)}
//           onAddEmployees={handleAddEmployees}
//           handleUploadExcel={handleUploadExcel}
//           handleDownloadTemplate={handleDownloadTemplate}
//           searchTerm={searchTerm}
//           setSearchTerm={setSearchTerm}
//           isEdit={isEdit}
//         />
//       )}

//       <Box className="individual-employees-table-shell" sx={{
//         maxHeight: { xs: "400px", sm: "322px" },
//         overflowY: "auto",
//         overflowX: "auto"
//       }}>
//         <EmployeeTable
//           currentRows={currentRows}
//           handleRemoveEmployee={handleRemoveEmployee}
//           page={page}
//           onDelete={handleDeleteEmployee}
//           onUndo={handleUndoEmployee}
//           rowsPerPage={rowsPerPage}
//         />
//       </Box>

//       <Box className="individual-employees-pagination" sx={{
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         mt: 4,
//         gap: 1,
//         flexWrap: { xs: 'wrap', sm: 'nowrap' }
//       }}>
//         <PaginationControls
//           page={page}
//           totalPages={totalPages}
//           onPageChange={handlePageChange}
//           renderPageNumbers={renderPageNumbers}
//         />
//       </Box>

//       <NotFoundEmployeesPopup
//         openNotFoundPopup={openNotFoundPopup}
//         setOpenNotFoundPopup={setOpenNotFoundPopup}
//         notFoundEmployeeCodes={notFoundEmployeeCodes}
//       />

//       <EmployeeLookupDialog
//         open={lookupOpen}
//         onClose={() => setLookupOpen(false)}
//         examId={examid}
//         selectedEmployees={selectedEmployees}
//         setSelectedEmployees={setSelectedEmployees}
//         onAddEmployees={handleAddEmployees}
//         setEmployees={setEmployees}   // ✅ NEW
//       />

//     </Box>
//   );
// };

// export default IndividualEmployeesTable;



import React, { useState, useEffect } from "react";
// import { Box, Typography } from "@mui/material";
import {
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import axios from "axios";
import EmployeeSelector from "../components/EmployeeSelector";
import EmployeeTable from "../components/EmployeeTable";
import PaginationControls from "../components/PaginationControls";
import NotFoundEmployeesPopup from "../components/NotFoundEmployeesPopup";
import EmployeeLookupDialog from "../components/EmployeeLookupDialog";
import { useEmployeeHandlers } from "../hooks/useEmployeeHandlers";

const IndividualEmployeesTable = ({ individuals, sendTableDataToParent, setError, examid, isEdit }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(1);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [notFoundEmployeeCodes, setNotFoundEmployeeCodes] = useState([]);
  const [openSuccessPopup, setOpenSuccessPopup] = useState(false);
  const [openNotFoundPopup, setOpenNotFoundPopup] = useState(false);
  const [openUploadErrorPopup, setOpenUploadErrorPopup] = useState(false);
  const [uploadErrorMessage, setUploadErrorMessage] = useState("");
  const [lookupOpen, setLookupOpen] = useState(false);
  const rowsPerPage = 10;
  const [employees, setEmployees] = useState([]);

  // ✅ Fetch employees for dropdown on component mount
  useEffect(() => {
    if (examid) {
      fetchEmployees();
      setSelectedEmployees([]);
    }
  }, [examid]);

  // const fetchEmployees = async () => {
  //   try {
  //     const res = await axios.post("/coordinators/employees-list/", {
  //       params: {
  //         exam_id: examid,
  //         page: 1,
  //         page_size: 20,
  //       },
  //     });
  //     const normalized = (res.data?.data || []).map((emp) => ({
  //       id: emp.GUID,
  //       employeeId: emp.EmployeeId,
  //       employeeName: emp.EmployeeName,
  //       departmentId: emp.DepartmentId,
  //       departmentName: emp.DepartmentName,
  //       GUID: emp.GUID,
  //       status: "Pending",
  //       isActive: true,
  //       assignmentId: 1,
  //     }));
  //     setEmployees(normalized);
  //   } catch (err) {
  //     console.error("Failed to fetch employees:", err);
  //   }
  // };


  const refreshAddedEmployeeStatuses = (employeeOptions = []) => {
    if (!Array.isArray(individuals) || individuals.length === 0) return;

    const employeeStatusMap = new Map(
      employeeOptions
        .filter((employee) => employee.GUID || employee.id)
        .map((employee) => [employee.GUID || employee.id, employee])
    );

    let changed = false;
    const refreshedIndividuals = individuals.map((employee) => {
      const matchingEmployee = employeeStatusMap.get(employee.GUID || employee.id);
      if (!matchingEmployee) return employee;

      const nextEmployee = {
        ...employee,
        assessmentStatus: matchingEmployee.assessmentStatus || "Available",
        userAttemptCount: matchingEmployee.userAttemptCount ?? 0,
        attemptCount: matchingEmployee.attemptCount ?? 1,
        isAssignedElsewhere: matchingEmployee.isAssignedElsewhere || false,
      };

      if (
        nextEmployee.assessmentStatus !== employee.assessmentStatus ||
        nextEmployee.userAttemptCount !== employee.userAttemptCount ||
        nextEmployee.attemptCount !== employee.attemptCount ||
        nextEmployee.isAssignedElsewhere !== employee.isAssignedElsewhere
      ) {
        changed = true;
      }

      return nextEmployee;
    });

    if (changed) {
      sendTableDataToParent?.(refreshedIndividuals);
    }
  };

  const fetchEmployees = async () => {
    try {
      const res = await axios.post(
        "/coordinators/employees-list/",
        {}, // body (empty if not needed)
        {
          params: {
            exam_id: examid,
            page: 1,
            page_size: 1000,
          },
        }
      );

      const normalized = (res.data?.data || []).map((emp) => ({
        isAssignedElsewhere: Boolean(
          emp.IsAlreadyAssigned ?? emp.isAlreadyAssigned ?? emp.AlreadyAssigned
        ),
        id: emp.GUID,
        employeeId: emp.EmployeeId,
        employeeName: emp.EmployeeName,
        departmentId: emp.DepartmentId,
        departmentName: emp.DepartmentName,
        GUID: emp.GUID,
        assessmentStatus: emp.AssessmentStatus || "Available",
        userAttemptCount: emp.UserAttemptCount ?? emp.userAttemptCount ?? 0,
        attemptCount: emp.AttemptCount ?? emp.attemptCount ?? 1,
        status: "Pending",
        isActive: true,
        assignmentId: 1,
      }));

      setEmployees(normalized);
      refreshAddedEmployeeStatuses(normalized);
    } catch (err) {
      console.error("Failed to fetch employees:", err);
    }
  };


  const {
    handleAddEmployees,
    handleRemoveEmployee,
    handleUploadExcel,
    handleDownloadTemplate,
    totalPages,
    currentRows,
    handlePageChange,
    renderPageNumbers,
    handleDeleteEmployee,
    handleUndoEmployee
  } = useEmployeeHandlers({
    individuals,
    sendTableDataToParent,
    setError,
    examid,
    searchTerm,
    page,
    setPage,
    selectedEmployees,
    setSelectedEmployees,
    notFoundEmployeeCodes,
    setNotFoundEmployeeCodes,
    openNotFoundPopup,
    setOpenNotFoundPopup,
    openSuccessPopup,
    setOpenSuccessPopup,
    setUploadErrorMessage,
    setOpenUploadErrorPopup,
    rowsPerPage
  });

  useEffect(() => {
    setPage(1);
  }, [searchTerm]);

  return (
    <Box className="individual-employees-section" sx={{ mb: 2 }}>
      <Box sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        justifyContent: "space-between",
        alignItems: { xs: "stretch", sm: "center" },
        gap: 1.5,
        mb: 1,
        mt: 3
      }}>
        <Typography variant="h6">Individual Employees</Typography>
      </Box>
      {!isEdit && (
        <EmployeeSelector
          employees={employees}
          selectedEmployees={selectedEmployees}
          setSelectedEmployees={setSelectedEmployees}
          onOpenLookup={() => setLookupOpen(true)}
          onAddEmployees={handleAddEmployees}
          handleUploadExcel={handleUploadExcel}
          handleDownloadTemplate={handleDownloadTemplate}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />
      )}
      <Box className="individual-employees-table-shell" sx={{
        // maxHeight: { xs: "400px", sm: "322px" },
        overflowY: "auto",
        overflowX: "auto"
      }}>
        <EmployeeTable
          currentRows={currentRows}
          handleRemoveEmployee={handleRemoveEmployee}
          page={page}
          onDelete={handleDeleteEmployee}
          onUndo={handleUndoEmployee}
          rowsPerPage={rowsPerPage}
        />
      </Box>
      <Box className="individual-employees-pagination" sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 1,
        flexWrap: { xs: 'wrap', sm: 'nowrap' }
      }}>
        <PaginationControls
          page={page}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      </Box>
      <NotFoundEmployeesPopup
        openNotFoundPopup={openNotFoundPopup}
        setOpenNotFoundPopup={setOpenNotFoundPopup}
        notFoundEmployeeCodes={notFoundEmployeeCodes}
      />
      <Dialog
        open={openSuccessPopup}
        onClose={() => setOpenSuccessPopup(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ position: "relative" }}>
          Success

          <IconButton
            onClick={() => setOpenSuccessPopup(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            textAlign: "center",
            py: 6,
            borderTop: "1px solid #e0e0e0",
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <Typography>
            All employees inserted successfully!
          </Typography>
        </DialogContent>

        <DialogActions
          sx={{
            justifyContent: "center",
            py: 3,
          }}
        >
          <Button
            onClick={() => setOpenSuccessPopup(false)}
            sx={{
              minWidth: "72px",
              height: "58px",
              borderRadius: "10px",
              border: "2px solid #32CD32",
              color: "#000",
              backgroundColor: "#fff",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "#fff",
                border: "2px solid #32CD32",
              },
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openUploadErrorPopup}
        onClose={() => setOpenUploadErrorPopup(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ position: "relative", fontWeight: 600 }}>
          Upload Failed

          <IconButton
            onClick={() => setOpenUploadErrorPopup(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            textAlign: "center",
            py: 6,
            borderTop: "1px solid #e0e0e0",
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <ErrorOutlineIcon
            sx={{
              fontSize: 64,
              color: "#d32f2f",
              mb: 2,
            }}
          />
          <Typography>
            {uploadErrorMessage || "Failed to upload one or more Excel files. Please try again."}
          </Typography>
        </DialogContent>

        <DialogActions
          sx={{
            justifyContent: "center",
            py: 3,
          }}
        >
          <Button
            onClick={() => setOpenUploadErrorPopup(false)}
            sx={{
              minWidth: "72px",
              height: "58px",
              borderRadius: "10px",
              border: "2px solid #32CD32",
              color: "#000",
              backgroundColor: "#fff",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "#fff",
                border: "2px solid #32CD32",
              },
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <EmployeeLookupDialog
        open={lookupOpen}
        onClose={() => setLookupOpen(false)}
        examId={examid}
        selectedEmployees={selectedEmployees}
        setSelectedEmployees={setSelectedEmployees}
        onAddEmployees={handleAddEmployees}
        onUndoEmployee={handleUndoEmployee}
        setEmployees={setEmployees}
        existingTableEmployees={individuals || []} />
    </Box>
  );
};

export default IndividualEmployeesTable;
